var GainUtil = (function () {
    'use strict';
    var api = {};

    api.format = function (gain, mode) {
        var tempGain = api.round(gain, mode);
        return NumberFormat.format(tempGain);
    };

    api.round = function (gain, mode, toFixed) {
        var tempGain = 0;
		toFixed = toFixed || 12;
        switch (mode) 
        {
            case GainRoundModes.ROUND:
            {
                tempGain = Math.round((gain * 100).toFixed(toFixed)) / 100;
                break;
            }
            case GainRoundModes.CEILING:
            {
                tempGain = Math.ceil((gain * 100).toFixed(toFixed)) / 100;
                break;
            }
            case GainRoundModes.FLOOR:
            default:
                {
                    // floor and legacy logic are the same
                    tempGain = Math.floor((gain * 100).toFixed(toFixed)) / 100;
                    break;
                }
        }

        return tempGain;
    }


    return api;
}());

window.GainUtil = GainUtil;
